import React from "react";
import { motion } from "framer-motion";
import "./loader.css";

const Loader = () => {
  return (
    <motion.section
      initial={{ opacity: 1 }}
      animate={{
        opacity: 0,
        transition: { duration: 0.8, ease: "easeInOut", delay: 2.5 },
        transitionEnd: { display: "none" }
      }}
      className="loader"
      style={{ zIndex: 9999, position: "fixed", inset: 0 }}
    >
      <div className="loader__container">
        <motion.span
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 0.5 },
            transitionEnd: {
              display: "none",
            },
          }}
          className="loader__text"
        >
          Halo
        </motion.span>
        <motion.span
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 0.8 },
            transitionEnd: {
              display: "none",
            },
          }}
          className="loader__text"
        >
          Hello
        </motion.span>
        <motion.span
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 1.1 },
            transitionEnd: {
              display: "none",
            },
          }}
          className="loader__text"
        >
          مرحبًا
        </motion.span>
        <motion.span
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            transition: { delay: 1.4 },
            transitionEnd: {
              display: "none",
            },
          }}
          className="loader__text"
        >
          こんにちは
        </motion.span>
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { delay: 1.7 } }}
          className="loader__text"
        >
          Привет
        </motion.span>
      </div>
    </motion.section>
  );
};

export default Loader;
